import BaseApiService from './BaseApiService';

import chartModel from '../../models/chartModel';

class ChartApiService extends BaseApiService {
    constructor() {
        super('chart');
    }

    toClientObject(serverObject) {
        let linesState = {};

        if(serverObject.filters.linesState !== undefined ){
            try {
                linesState = JSON.parse(serverObject.filters.linesState)
            } catch (error) {
                console.error(error);
            }
        }

        const clientObject = {
            ...chartModel,
            ...serverObject,
            state: 'view',
            filters: {
                ...serverObject.filters,
                open: false,
                chartType: serverObject.type,
                range: serverObject.filters.range && serverObject.filters.range.length > 0
                    ? serverObject.filters.range[0]
                    : null,
                revenueFilterRange: serverObject.filters.revenueFilterRange && serverObject.filters.revenueFilterRange.length > 0
                    ? serverObject.filters.revenueFilterRange[0]
                    : null,
                revenues: serverObject.filters.revenues && serverObject.filters.revenues.length > 0
                    ? serverObject.filters.revenues[0]
                    : null,
                linesState: linesState,
            },
        };

        delete clientObject.type;

        return clientObject;
    }

    toServerObject(clientObject) {
        const serverObject = {
            name: clientObject.name,
            type: clientObject.filters.chartType,
            xDomainLow: (!clientObject.drawingService || typeof clientObject.drawingService.xDomain === 'undefined') ? 0 : clientObject.drawingService.xDomain[0],
            xDomainHigh: (!clientObject.drawingService || typeof clientObject.drawingService.xDomain === 'undefined') ? 0 : clientObject.drawingService.xDomain[1],
            yDomainLow: (!clientObject.drawingService || typeof clientObject.drawingService.yDomain === 'undefined') ? 0 : clientObject.drawingService.yDomain[0],
            yDomainHigh:(!clientObject.drawingService || typeof clientObject.drawingService.yDomain === 'undefined') ? 0 : clientObject.drawingService.yDomain[1],
            filters: {
                companies: clientObject.filters.companies,
                categories: clientObject.filters.categories,
                subcategories: clientObject.filters.subcategories,
                classes: clientObject.filters.classes,
                growthRates: clientObject.filters.growthRates,
                growthRatesQuarters: clientObject.filters.growthRatesQuarters,
                range: (clientObject.filters.range !== null  && clientObject.filters.range!=='') ? [clientObject.filters.range] : [],
                revenueFilterRange: clientObject.filters.revenueFilterRange !== null ? [clientObject.filters.revenueFilterRange] : [],
                revenues: clientObject.filters.revenues !== null ? [clientObject.filters.revenues] : [],
                brands: clientObject.filters.brands,
                excludeBrands: clientObject.filters.excludeBrands,
                quarterData: clientObject.filters.quarterData,
                tags: clientObject.filters.tags,
                curves: clientObject.filters.curves,
                scaleLogType: clientObject.filters.scaleLogType,
                showStopIcon: clientObject.filters.showStopIcon,
                legendSort: clientObject.filters.legendSort,
                cumulativeType: clientObject.filters.cumulativeType !== null ? clientObject.filters.cumulativeType : 'none',
                showCumulativeRevenueChart: clientObject.filters.showCumulativeRevenueChart !== undefined && clientObject.filters.showCumulativeRevenueChart !== null ? clientObject.filters.showCumulativeRevenueChart : false,
                startSyncView: clientObject.filters.startSyncView !== undefined && clientObject.filters.startSyncView !== null ? clientObject.filters.startSyncView : false,
                showLoe: clientObject.filters.showLoe !== undefined && clientObject.filters.showLoe !== null ? clientObject.filters.showLoe : false,
                linesState: clientObject.filters.linesState !== undefined ? JSON.stringify(clientObject.filters.linesState) : null,
                colorByFicBic: clientObject.filters.colorByFicBic !== undefined && clientObject.filters.colorByFicBic !== null ? clientObject.filters.colorByFicBic : false,
            },
        };

        if (clientObject.id) {
            serverObject.id = clientObject.id;
        }

        return serverObject;
    }

    async get({ id }) {
        const response = await this.request({ method: 'GET', url: `/${id}` });
        return response && response.chart ? this.toClientObject(response.chart) : {};
    }

    async getAll() {
        const response = await this.request({ method: 'GET', url: '' });
        return response && response.charts ? response.charts.map(chart => this.toClientObject(chart)) : [];
    }

    async save({ chart }) {
        const data = this.toServerObject(chart);

        const response = await this.request({ method: 'POST', url: '', data });
        return response && response.chart ? this.toClientObject(response.chart) : {};
    }

    async rename({ chart }) {
        const data = {
            id: chart.id,
            name: chart.name,
        };

        const response = await this.request({ method: 'POST', url: '/renameChart', data });
        return response && response.chart ? this.toClientObject(response.chart) : {};
    }

    async delete({ id }) {
        return this.request({ method: 'DELETE', url: `/${id}` });
    }
}

export default new ChartApiService();
